import React from 'react';
import ReactDOM from 'react-dom';
import { Provider } from 'react-redux';
import thunkMiddleware from 'redux-thunk';
import { createStore, applyMiddleware } from 'redux';
import * as Sentry from '@sentry/browser';

import './index.css';
import { ConnectedApp } from './components/App';
import { unregister as unregisterServiceWorker } from './registerServiceWorker';
import { rootReducer } from './store';
import { AppErrorBoundary } from './components/AppErrorBoundary/AppErrorBoundary';

const store = createStore(rootReducer, applyMiddleware(thunkMiddleware));

const env = process.env.REACT_APP_BUILD_ENV;
if (env === 'production' || env === 'staging') {
  Sentry.init({
    dsn: 'https://033fb52bf903485cb67f49d66dbc13d8@sentry.io/1314906',
    environment: env,
  });
}

ReactDOM.render(
  <AppErrorBoundary>
    <Provider store={store}>
      <ConnectedApp />
    </Provider>
  </AppErrorBoundary>,
  document.querySelector('.react-app'),
);
unregisterServiceWorker();
